import { useLocation, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import axiosInstance from '../../../../../utils/AxiosInstance';
import BLoader from '../../../../../components/BLoader';
import { BButton, BCard } from '../../../../../components/ui/generic';

const Succes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifying, setIsVerifying] = useState(true);
  const verify = async (status, session_id) => {
    setIsVerifying(true);
    const res = await axiosInstance.post(
      `/internal_api/payment-method/verify?status=${status}&session_id=${session_id}`
    );
    setIsVerifying(false);
    if (res.status === 200) {
      const { data } = res;
      if (!data.error) {
        setIsVerified(true);
      } else {
        setIsVerified(false);
      }
    }
  };
  useEffect(() => {
    if (!isVerified) {
      const queryParams = new URLSearchParams(location.search);
      const status = queryParams.get('status');
      const sessionId = queryParams.get('session_id');
      if (status === 'success' && sessionId) {
        setIsStatusSuccess(true);
        verify(status, sessionId);
      }
    }
  }, [location.search, isVerified]);
  if (isVerifying) {
    return <BLoader />;
  }
  return (
    <BCard maxSize={'md:max-w-2xl'} className={'mt-20'} outlineColor={'outline-primary-700'}>
      <BCard.Body>
        <div className={'flex items-center gap-2 px-8'}>
          <p className={'text-xl font-medium text-slate-700'}>Carte mis à jour</p>
        </div>
        <p className={'px-8 text-slate-700'}>Votre carte bancaire a bien été mis à jour.</p>

        <div className={'flex w-full justify-center gap-2.5'}>
          <div className={''}>
            <BButton label={"Retourner à l'acceuil"} size={'lg'} onClick={() => navigate('/')} />
          </div>
        </div>
      </BCard.Body>
    </BCard>
  );
};

export default Succes;
